module.exports = __webpack_public_path__ + "static/media/c-hungarian.76e2cead.jpg";